import React from "react";
import makeStyles from '@mui/styles/makeStyles';
// @mui/icons-material
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Badge from "components/Badge/Badge.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";

import sectionBlogInfoStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionBlogInfoStyle.js";

const useStyles = makeStyles(sectionBlogInfoStyle);

export default function SectionBlogInfo() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={10} md={8}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <div className={classes.blogTags}>
                Tags:
                <Badge color="warning">Social Media</Badge>
                <Badge color="warning">Marketing</Badge>
                <Badge color="warning">LinkedIn Campaigns</Badge>
              </div>
            </GridItem>

          </GridContainer>
          <hr />
          <Card plain profile className={classes.card}>
            <GridContainer>
              <GridItem xs={12} sm={2} md={2}>
                <CardAvatar plain profile>
                  <img src="/img/faces/Victoria.png" alt="..." />
                </CardAvatar>
              </GridItem>
              <GridItem xs={12} sm={8} md={8}>
                <h4 className={classes.cardTitle}>Victoria Prodromidis</h4>
                <p className={classes.description}>
                Marketing is no longer about the stuff that you make, but the stories you tell.

                </p>
              </GridItem>

            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
